export interface TesSection {
  id: number;
  nr: string; // kolejny numer TES (np. "1")
  range: string; // zakres pozycji, np. "1-214"
  name: string;  // nazwa działu
  total: number; // kwota netto
}

// Parsuje zakres "1-214" na krotkę [1, 214]
export const parseRange = (range: string): [number, number] | null => {
  const m = range.match(/(\d+)\s*-\s*(\d+)/);
  if (!m) return null;
  return [parseInt(m[1], 10), parseInt(m[2], 10)];
};

// Porównuje numer działu w formacie 1, 1.2, 2.10 itd.
export const compareSectionNr = (a: string, b: string): number => {
  const as = a.split('.').map(Number);
  const bs = b.split('.').map(Number);
  const len = Math.max(as.length, bs.length);
  for(let i=0;i<len;i++){
    const av = as[i] ?? 0;
    const bv = bs[i] ?? 0;
    if(av!==bv) return av-bv;
  }
  return 0;
};

// Zwraca TesSection, do którego należy podany numer pozycji
export const getSectionForNr = (nr: string | number, tesRows: TesSection[]): TesSection | null => {
  const posNr = typeof nr === 'string' ? parseInt(nr, 10) : nr;
  if (isNaN(posNr)) return null;
  for (const row of tesRows) {
    const rng = parseRange(row.range);
    if (rng && posNr >= rng[0] && posNr <= rng[1]) {
      return row;
    }
  }
  return null;
};

// Zwraca najbardziej szczegółowy (najdłuższy nr) dział obejmujący daną pozycję
export const findBestSection = (posNr:number, sections:TesSection[]): TesSection | null => {
  const matches = sections.filter(sec=>{
    const rng = parseRange(sec.range);
    return rng && posNr>=rng[0] && posNr<=rng[1];
  });
  if(matches.length===0) return null;
  matches.sort((a,b)=>{
    const depthDiff = b.nr.split('.').length - a.nr.split('.').length;
    if(depthDiff!==0) return depthDiff;
    return compareSectionNr(a.nr,b.nr);
  });
  return matches[0];
}; 